import { CryptoCurrency } from '@quickbit/qb-design-system';
import { useState } from 'react';
import { useAsync, useAsyncFn } from 'react-use';
import { useOrderId } from 'context';
import { useCountdown } from 'hooks';
import {
  createPreview,
  PreviewResponse,
  updatePreview,
  getPreview,
} from '../api';

const PREVIEW_REFRESH_RATE_SECONDS = 15 * 60;

export const usePreview = () => {
  const orderId = useOrderId();
  const [preview, setPreview] = useState<PreviewResponse>();

  const [{ error: updateError }, refreshPreview] = useAsyncFn(async () => {
    const updated = await updatePreview(orderId);
    setPreview(updated);
  }, [orderId]);

  const { start: startTimer, timer } = useCountdown({
    from: PREVIEW_REFRESH_RATE_SECONDS,
    restart: true,
    onEnd: refreshPreview,
  });

  const { error: fetchPreviewError, loading: fetchPreviewLoading } =
    useAsync(async () => {
      try {
        const previewResponse = await getPreview(orderId);
        // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
        if (previewResponse) {
          const updated = await updatePreview(orderId);
          setPreview(updated);
          startTimer();
        }
      } catch (error) {
        // Preview not found, do nothing
        console.log(error);
      }
    }, [orderId]);

  const [{ error: previewError, loading }, createPreviewFn] = useAsyncFn(
    async (currency: CryptoCurrency) => {
      const previewResponse = await createPreview(orderId, currency);
      setPreview(previewResponse);
      startTimer();
    },
    [orderId, startTimer]
  );

  return {
    preview,
    timer,
    error: previewError ?? fetchPreviewError ?? updateError,
    loading: loading || fetchPreviewLoading,
    createPreview: createPreviewFn,
  };
};
